import { useState } from 'react';
import { Link } from '@inertiajs/react';

function DeleteProductButton({ product }) {
  const [isConfirmOpen, setConfirmOpen] = useState(false);

  return (
    <>
      <div className='inline-block ml-2'>
        <button
          onClick={() => setConfirmOpen(true)}
          className='rounded-lg py-3 px-5 bg-gray-100 text-gray-800 font-medium hover:bg-gray-200 transition-colors'
          type='button'
        >
          Delete
        </button>
      </div>

      {isConfirmOpen && (
        <div
          className='fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-10'
          aria-modal='true'
          role='dialog'
        >
          <div className='bg-white rounded-lg shadow-xl p-6 w-full max-w-sm'>
            <h2 className='text-xl font-bold text-gray-900'>Are you sure?</h2>
            <p className='mt-2 text-gray-600'>
              This will permanently delete the product "{product.name}"
            </p>

            <div className='mt-6 flex justify-end gap-3'>
              <button
                onClick={() => setConfirmOpen(false)}
                className='rounded-lg py-2 px-4 bg-[var(--color-yellow-primary)] font-medium hover:bg-[var(--color-yellow-secondary)] hover:text-neutral-900'
              >
                Cancel
              </button>

              <Link
                href={`/products/${product.id}`}
                as='button'
                method='delete'
                preserveScroll
                onSuccess={() => setConfirmOpen(false)}
                className='rounded-lg py-2 px-4 bg-red-600 text-white font-medium hover:bg-red-700'
              >
                Delete
              </Link>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default DeleteProductButton
